/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import FirstView from '../../asset/firstview.png';
import TheLayout from '../../layout/TheLayout';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import interviewLinkImg from '../../asset/Interviews/interview01.jpg';
import interviewImg1 from '../../asset/Interviews/Interview01/interview01_1.jpg';
import interviewImg2 from '../../asset/Interviews/Interview01/interview01_2.jpg';
import './interview_article.css';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Interview01 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const conversations = [
    {
      question: 'TERRA　FORESTAはいつくらいにご導入をされましたか。',
      answer: '2021年6月にサロンをオープンしましたので、オープン時から導入しております。',
    },
    {
      question: 'コロナ禍のなか、オープンをされたのですね。',
      answer: 'はい、まだ全国的にコロナ感染者が多くいるなか当サロンはオープンをしました。',
    },
    {
      question: 'エステサロンというご業種がら、お客様もスタッフ様も肌に触れるので非常にコロナ感染を気にされると思うのですが、何か気をつけていることなどありましたか。',
      answer: `はい、まだ全国的にエステサロン、リラクゼーションはお客様の距離も近いですし、肌にも触れるので、お客様も不安になっている方が多いんです。<br />
      当社はましてやコロナ真っただ中で新規オープンをした立場でしたので、人一倍除菌に気を使い、多くの除菌液と比較しましたが、やはりオーガニック除菌が一番体に優しくしっかりした感染対策がとれると思いTERRAの商品を導入致しました。`,
    },
    {
      question: 'TERRA FORESTA商品はどのくらいの頻度でご利用されてますか。',
      answer: `毎日利用しています。<br />
      タワー型の加湿器はお客様がいらっしゃる際は必ずつけており、スプレータイプでイスやベッド、ドアノブなど除菌をし、入口にはハンディタイプを置いて利用しています。`,
      img: interviewImg1,
    },
    {
      question: '毎日ご利用となりますと、どのくらいの頻度で新しく注文するんですか。',
      answer: `定期便で届くので1カ月に1回新しい液剤が届きます。<br>
      毎日利用していて、だいたい1,000㎖を使いきれるので、ちょうどいい量です。<br>
      毎日忙しいので、中途半端な量だと追加注文したり、余ってしまったりなどあると思うのですが、そういうこともないので、非常に楽です。`,
    },
    {
      question: '除菌液の種類は多くありますが、なぜTERRA　FORESTAを選びましたか。',
      answer: `ドラッグストアやスーパーなどでも多く販売していますが、やはり肌に使うものなので不要な物を取り除いたオーガニック素材という点、そして、TERRAは光触媒コーティングも行っている会社なので、ただ商品を販売している会社とは違うなと思い、この部分が利用し始めたきっかけになりました。<br>
      私たちは、業種がらこのような肌に触れる液体にこだわってしまうのですが、どうしても化合物は鉱物が入っている液剤は、あの七色の油のような色を思い出してしまい、肌にはつけられないと思ってしまうんです。<br>
      TERRAの商品は化合物が一切混入されていないので、とても安心して使っております。`,
    },
    {
      img: interviewImg2,
    },
    {
      question: 'TERRAの商品を導入して何か変化はありましたか。',
      answer: `オーガニック除菌をしていることで、お客様からも安心できるねとお声がけを頂いたり、ホットペッパー、看板、ホームページにも除菌対策の旨を記載しているので、新規のお客様も除菌対策をきちんとしているからという理由でご来店頂いたこともあります。<br>
      当サロンは、現在でもコロナの新しい株が出てきて流行っておりますので、せっかくご来店頂けるお客様に安心してご利用して頂くためにもオーガニック除菌は必要だと思ってます。`,
    },
    {
      question: 'TERRAの商品をどういう人に薦めたいですか。',
      answer: 'ご来店頂くお客様にもお勧めすることもありますが、TERRAのタワー型は形も置きやすく、デザインもスッキリして香りもいいので全ての方にお勧めできます。',
    },
    {
      question: '最後に TERRAに一言ございますか。',
      answer: 'オーガニック除菌は、私たちにとって安心して利用できる商品なので、今後も是非利用させてください。',
    },
  ];

  const renderQnA = () => conversations.map((qna) => (
    <div className="row interview-qna" key={qna.question}>
      {
        qna.img
        && (
          <div className="col">
            <img src={qna.img} style={{ width: '100%' }} alt="" />
          </div>
        )
      }
      {
        qna.question
        && (
          <div className="col">
            <div className="interview-question">
              <span className="interview-question-dash" />
              {qna.question}
            </div>
            <div className="interview-answer" dangerouslySetInnerHTML={{ __html: qna.answer }} />
          </div>
        )
      }
    </div>
  ));

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>お客様の声｜株式会社TERRA</title>
      </Helmet>
      <div className="interview-introduction-detail">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          お客様の声
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>お客様の声</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container p-0">
          <div className="row m-0">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9 p-0">
              <div
                className="m-auto p-0 p-lg-5"
              >
                <div className="interview-post-container">
                  <h4 className="interview-post-title">
                    エステティックサロンオーナーがお勧めしたい！
                    <br />
                    肌に優しいオーガニック除菌
                  </h4>
                  <div>
                    <img src={interviewLinkImg} style={{ width: '100%' }} alt="VivaceImg" />
                  </div>
                  <div>
                    <div className="interview-name">
                      TERRA商品をご愛用者様ご利用の声vol,1
                    </div>
                    <div className="interview-intro">
                      エステ・リラクゼーションサロンを運営されている
                      <span>「Vivace」</span>
                      周藤様に
                      <br />
                      ご導入のきっかけなどをお伺い致しました。
                    </div>
                  </div>
                  <div className="interview-conversations">
                    {renderQnA(conversations)}
                  </div>
                  <div className="interview-end">
                    <p>インタビュー協力</p>
                    <p>ボディメンテナンス＆エステサロン「Vivace」</p>
                    <p>周藤　詩織様</p>
                    <a
                      className="interview-vivace-link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://vivace-vtin.com/"
                      style={{ color: '#0000FF' }}
                    >
                      https://vivace-vtin.com/
                    </a>
                    <p>取材・文</p>
                    <p>ARIA株式会社　青山　綾子</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Interview01;
